import { useState } from 'react';

// Shared initial fonts list so it can be reused in Redux slice as well.
export const initialFonts = [
  { label: 'Plus Jakarta Sans', value: 'Plus Jakarta Sans' },
  { label: 'Dancing Script', value: 'Dancing Script' },
  { label: 'Outfit', value: 'Outfit' },
  { label: 'Quicksand', value: 'Quicksand' },
  { label: 'Roboto', value: 'Roboto' },
  { label: 'Playfair Display', value: 'Playfair Display' },
  { label: 'Lato', value: 'Lato' },
  { label: 'PT Sans', value: 'PT Sans' },
  { label: 'IBM Plex Sans', value: 'IBM Plex Sans' },
  { label: 'Montserrat', value: 'Montserrat' },
  { label: 'Merriweather', value: 'Merriweather' },
];

// Hook is kept for backward compatibility in components that still rely on local state.
export const useAllFonts = () => {
  const [allFonts, setAllFonts] = useState(initialFonts);

  return [allFonts, setAllFonts];
};
